import React, { useState } from "react";
import styles from "./Card.module.scss";

const Card = () => {
  const [cardNum, setCardNum] = useState("1234 1234 1234 1234");
  const [expiry, setExpiry] = useState("02/23");
  const [cvc, setCvc] = useState("123");
  const [postal, setPostal] = useState("76584");

  return (
    <div className={styles.container}>
      <form>
        <div className={styles.field}>
          <label>Card number</label>
          <input
            type="text"
            value={cardNum}
            onChange={(e) => setCardNum(e.target.value)}
          />
        </div>

        <div className={styles.fieldRow}>
          <div className={styles.field}>
            <label>Expiry</label>
            <input
              type="text"
              value={expiry}
              onChange={(e) => setExpiry(e.target.value)}
            />
          </div>

          <div className={styles.field}>
            <label>CVC</label>
            <input
              type="text"
              value={cvc}
              onChange={(e) => setCvc(e.target.value)}
            />
          </div>
        </div>

        <div className={styles.fieldRow}>
          <div className={styles.field}>
            <label>Country</label>
            <select name="country">
              <option value="United States">United States</option>
              <option value="United States">United States</option>
              <option value="United States">United States</option>
              <option value="United States">United States</option>
            </select>
          </div>

          <div className={styles.field}>
            <label>Postal code</label>
            <input
              type="text"
              value={postal}
              onChange={(e) => setPostal(e.target.value)}
            />
          </div>
        </div>

        <div className={styles.btnContainer}>
          <button>Delete Card</button>
          <button>Save Changes</button>
        </div>
      </form>
    </div>
  );
};

export default Card;
